/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Flex, Box, Image, Text, HStack } from '@chakra-ui/react';
import Tooltips from './Tooltips';

interface Props {
  data: any;
  phoneWidth: number;
}

const CarouselStories: React.FC<Props> = ({ data, phoneWidth }) => {
  const padding = 4;
  return (
    <Box
      position="relative"
      w={phoneWidth - 8}
      _hover={{ bg: 'gray.200' }}
      backgroundColor="gray.100"
      borderRadius="6px"
      transition="150ms ease"
      p={`${padding}px`}
    >
      {data?.name ? (
        <>
          <Flex align="center" px={4}>
            <Text fontWeight="bold" fontSize="lg" mr={2}>
              {data?.name}
            </Text>
            <Tooltips data={data} />
          </Flex>
          {!!data?.description && (
            <Text fontSize="xs" color="gray.400" px={4}>
              {data.description}
            </Text>
          )}
        </>
      ) : (
        <Flex position="absolute" left={2} top={1}>
          <Tooltips data={data} />
        </Flex>
      )}
      <HStack overflow="auto" mt={4}>
        {data?.items?.map((banner: any) => (
          <Flex align="center" flex="none" key={banner?.id} p={1}>
            {banner?.file?.url && (
              <Image
                h="60px"
                borderRadius="50px"
                p={1}
                backgroundColor="white"
                mb={2}
                src={banner.file.url}
              />
            )}
          </Flex>
        ))}
      </HStack>
    </Box>
  );
};

export default CarouselStories;
